export const eligibleKey = "eligible";
export const johnAccountKey = "johnAccount";